export class Images {
    static moduleName = 'images';
    static listTitle = 'Справочник изображений';
    static createTitle = 'Добавление нового изображения';
    static apiPrefix = '/images';
}